import { FC, useEffect } from 'react'

import { useMaskDrawer } from './MaskDrawer.context'

export const DEFAULT_BRUSH_SIZE = 40

/**
 * @example 
 * <MaskDrawer />
 */
export const MaskDrawer: FC = () => {

  const {
    handleMouseDown,
    handleMouseUp,
    handleMouseMove,
    imageRef,
    previewImageMagicEraser,
    previewMaskCanvasRef,
    storedMaskCanvasRef,
    previewImageSizeRef,
    syncCanvasSize
  } = useMaskDrawer()

  useEffect(() => {
    const img = imageRef.current
    if (!img) return

    if (img.complete) {
      previewImageSizeRef.current = {
        width: img.naturalWidth,
        height: img.naturalHeight,
      }
      syncCanvasSize()
    } else {
      img.onload = () => {
        previewImageSizeRef.current = {
          width: img.naturalWidth,
          height: img.naturalHeight,
        }
        syncCanvasSize()
      }
    }
    // skip syncCanvasSize()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [previewImageMagicEraser, imageRef, previewImageSizeRef])

  return (
    <div>

      {/* TODO REMOVE AFTER CONNECTED TO BE, FOR DEBUGGING */}
      {/* <Button variant="contained" onClick={exportMask} disabled={!canvasReady} style={{ marginLeft: 12 }}>
          Export Mask
        </Button> */}

      <div
        style={{
          position: 'relative',
          display: 'inline-block',
        }}
      >
        {/* Loaded image preview */}
        <img
          ref={imageRef}
          src={previewImageMagicEraser}
          alt="loaded_visual_for_edit_in_mask_drawer"
          style={{
            display: 'block',
            objectFit: 'contain', // Ensures the whole image is visible when portrait or landscape
            pointerEvents: 'none', // Prevent image from capturing mouse events
            margin: 'auto',
            maxWidth: '100%',
            maxHeight: '100%',
            width: 'auto',
            height: 'auto',
            objectPosition: 'center',
          }}
        />

        {/* Canvas overlay for mask preview with opacity */}
        <canvas
          ref={previewMaskCanvasRef}
          id='previewMaskCanvas'
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            maxWidth: '100%',
            maxHeight: '100%',
            width: 'auto',
            height: 'auto',
            pointerEvents: 'auto',
            cursor: 'crosshair',
            background: 'transparent', // Ensure canvas is transparent
          }}
          onMouseDown={handleMouseDown}
          onMouseUp={handleMouseUp}
          onMouseLeave={handleMouseUp}
          onMouseMove={handleMouseMove}
        />

        {/* Offscreen (hidden) canvas to store the actual mask, and just draw the visual preview with transparency on canvas overlay */}
        <canvas
          ref={storedMaskCanvasRef}
          id='storedMaskCanvas'
          style={{
            display: 'none', // Hide this canvas, it's only used for storing the mask
            position: 'absolute',
            top: 0,
            left: 0,
            maxWidth: '100%',
            maxHeight: '100%',
            width: 'auto',
            height: 'auto',
            pointerEvents: 'none',
          }}
        />
      </div>
    </div>
  )
}
